export default {
    data() {
        return {
            // inject:['reload'],
            all: 0, //总页数
            cur: 1,//当前页码
            payLenth: 0,
            completedLenth: 0,
            expiredLenth: 0,
            boughtFlag: '',
            // 商品的数组
            orders: [],
            // 支付方式的数组
            pay_type: ['支付宝', '微信', '线下开通', '银联', '账号余额'],
            // 每页显示条数
            pageSize: 10,
            // 当前页
            currentPage: 1,
            // 总页数
            total: 0,
            // 默认选择的导航栏菜单项
            activeIndex: '1',
            // 发送请求订单需要的默认数据
            data: {
                token: this.$store.state.id,
                offset: 0,
                length: 10
            },
            // 订单的状态
            state: ''
        }
    },
    methods: {
        //去支付，跳转支付中心
        goPaycenter: function (orderId, categoryList) {
            // 跳转到支付页面
            this.$router.push({
                path: '/paycenter',
                query: {
                    order_id: orderId,
                    // categoryList中对象的属性名跟paycenter页面使用的属性名不一致，这边更换一下属性名
                    commodityList: JSON.stringify(categoryList).replace(/category_/g, '')
                }
            });
        },

        //全部页和未支付页的取消订单
        cancelOrder: function (id) {
            this.$post('orders/cancel', { id: id, token: this.$store.state.id, state: '5' }).then(() => {
                this.getMyorder();
            })
        },

        //获取订单数据
        getMyorder: function () {
            this.$post('orders/search_order', this.data).then(res => {
                this.orders = res.data.result.data;
                this.total = res.data.result.total;
            })
        },
        //判断商品是否已经购买过了
        isBought: function (orderId, categoryList) {
            // 查询这个订单对应的课程包
            this.$post('category_order/get_order_id', {
                order_id: orderId,
                offset: 0,
                length: 999
            }).then(res => {
                // 获取订单对应的课程包数组
                let categoryIds = res.data.result.data.map(item => item.category_id);

                // 发送请求查询用户是否有购买过该课程包
                this.$post('orders/paid_order', {
                    token: this.$store.state.id,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // list是用户state等于2的订单数组
                    let list = res.data.result.data.map(item => item.id);

                    // 发送请求，查看是否已经购买过当前的课程包
                    this.$post('category_order/search', {
                        category_ids: JSON.stringify(categoryIds),
                        order_ids: JSON.stringify(list),
                        offset: 0,
                        length: 999
                    }).then(res2 => {

                        let list2 = res2.data.result.data;

                        if (list2.length === 0) {
                            // 用户没有购买过这个课程包
                            this.goPaycenter(orderId, categoryList);
                        } else {
                            // 用户购买过该课程包
                            this.$messgae.error('您的订单中有重复购买的商品！')
                        }
                    });
                });
            });
        },

        // 返回订单状态
        returnOrderState(state) {
            let stateStr = '';
            switch (Number.parseInt(state)) {
                case 0:
                    stateStr = '未支付';
                    break;
                case 2:
                    stateStr = '已支付';
                    break;
                case 5:
                    stateStr = '已失效';
                    break;
            }
            return stateStr;
        },

        // 返回订单支付方式
        returnOrderPay(type) {
            let typeStr = '';
            switch (Number.parseInt(type)) {
                case 1:
                    typeStr = '支付宝';
                    break;
                case 2:
                    typeStr = '微信';
                    break;
                case 3:
                    typeStr = '批量开课';
                    break;
                case 5:
                    typeStr = '账号余额';
                    break;
                case 6:
                    typeStr = '郑州银行';
                    break;
                default:
                    typeStr = '未支付';
            }
            return typeStr;
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.data = {
                token: this.$store.state.id,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                state: this.state
            }
            this.getMyorder()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.data = {
                token: this.$store.state.id,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                state: this.state
            }
            this.getMyorder()
        },

        // 选择导航栏标签时调用
        handleSelect(index) {
            // 先将state置为空，防止选完别的标签再选择所有订单标签
            this.state = '';
            let data = {
                token: this.$store.state.id,
                offset: 0,
                length: 10
            };
            /*
            * 1 是全部订单，全部订单使用默认的data就可以了
            * 2 是未支付订单
            * 3 是已完成订单
            * 4 是已失效订单
            */
            switch (index) {
                case '2':
                    data.state = 0;
                    this.state = 0;
                    break;
                case '3':
                    data.state = 2;
                    this.state = 2;
                    break;
                case '4':
                    data.state = 5;
                    this.state = 5;
                    break;
            }
            this.data = data;
            this.getMyorder();
        },
    },

    created: function () {
        this.getMyorder();
    },
    mounted: function () {
        document.title = '我的订单';
    }
}

